export const PENDIENTE = 'pendiente';
export const VERIFICANDO = 'verificando';
export const ERROR = 'error';
export const EXITO = 'exito';
